// app/javascript/controllers/random_pantone_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label"]

  connect() {
    this.applyRandomColor()
  }

  applyRandomColor() {
    const colors = [
      { name: "Blush Pink", hex: "#FDEEEF" },
  { name: "Pale Peach", hex: "#FFF0E5" },
  { name: "Baby Blue", hex: "#EAF4FF" },
  { name: "Mint Cream", hex: "#E9FFF5" },
  { name: "Lavender Mist", hex: "#F2ECFA" },
  { name: "Lemon Chiffon", hex: "#FFFDEB" },
  { name: "Ice Gray", hex: "#F5F5F5" },
  { name: "Powder Rose", hex: "#FFF2F4" },
  { name: "Sky Mist", hex: "#F0F8FF" },
  { name: "Cotton Candy", hex: "#FDF1FA" },
  { name: "Apricot Ice", hex: "#FFEFE0" },
  { name: "Soft Lilac", hex: "#F3F0FF" },
  { name: "Sea Foam", hex: "#E8FFF7" },
  { name: "Buttercream", hex: "#FFFBEA" },
  { name: "Snow Drift", hex: "#FFFFFF" },
  { name: "Vanilla Mist", hex: "#FFF9E9" },
  { name: "Pale Mauve", hex: "#F8F0F7" },
  { name: "Bluebell Haze", hex: "#EDF2FF" },
  { name: "Pastel Mint", hex: "#E6FFF6" },
  { name: "Cloud White", hex: "#FAFAFA" }
    ]

    const chosen = colors[Math.floor(Math.random() * colors.length)]
    document.body.style.backgroundColor = chosen.hex

    if (this.hasLabelTarget) {
      this.labelTarget.innerText = `Color: ${chosen.name} (${chosen.hex})`
    }
  }
}
